import { AppState, InputEventType } from './constants.js';

const transitionTable = {
  [AppState.CLOSED]: {
    [InputEventType.GO_DISPERSED]: AppState.DISPERSED,
    [InputEventType.ENTER_PHOTO_FOCUS]: null,
    [InputEventType.GO_CLOSED]: AppState.CLOSED,
    [InputEventType.EXIT_PHOTO_FOCUS]: AppState.CLOSED
  },
  [AppState.DISPERSED]: {
    [InputEventType.GO_CLOSED]: AppState.CLOSED,
    [InputEventType.GO_DISPERSED]: AppState.DISPERSED,
    [InputEventType.ENTER_PHOTO_FOCUS]: AppState.PHOTO_FOCUS,
    [InputEventType.EXIT_PHOTO_FOCUS]: AppState.DISPERSED
  },
  [AppState.PHOTO_FOCUS]: {
    [InputEventType.GO_CLOSED]: AppState.CLOSED,
    [InputEventType.GO_DISPERSED]: AppState.DISPERSED,
    [InputEventType.ENTER_PHOTO_FOCUS]: AppState.PHOTO_FOCUS,
    [InputEventType.EXIT_PHOTO_FOCUS]: AppState.DISPERSED
  }
};

export class AppStateMachine {
  constructor(initialState = AppState.CLOSED) {
    this.state = initialState;
    this.focusedPhotoIndex = null;
  }

  snapshot() {
    return {
      state: this.state,
      focusedPhotoIndex: this.focusedPhotoIndex
    };
  }

  dispatch(inputEvent, payload = {}) {
    const nextState = transitionTable[this.state]?.[inputEvent] ?? null;
    if (!nextState) {
      return {
        ok: false,
        reason: `Illegal transition: ${this.state} -> ${inputEvent}`,
        snapshot: this.snapshot()
      };
    }

    if (inputEvent === InputEventType.ENTER_PHOTO_FOCUS) {
      if (typeof payload.photoIndex !== 'number') {
        return {
          ok: false,
          reason: 'Missing photoIndex for ENTER_PHOTO_FOCUS',
          snapshot: this.snapshot()
        };
      }
      this.focusedPhotoIndex = payload.photoIndex;
    }

    if (
      inputEvent === InputEventType.GO_CLOSED ||
      inputEvent === InputEventType.GO_DISPERSED ||
      inputEvent === InputEventType.EXIT_PHOTO_FOCUS
    ) {
      this.focusedPhotoIndex = null;
    }

    this.state = nextState;

    return {
      ok: true,
      snapshot: this.snapshot()
    };
  }
}
